export const messages = {
  en: {
    productLabelManage: {
      queryCondition: 'Query Conditions',
      selectLabel: 'Please select product label',
      inputProductName: 'Please input product name',
      inputProductId: 'Please input product ID',
      labeledProducts: 'Labeled Products',
      labelName: 'Label Name',
      productId: 'Product ID',
      productImage: 'Product Image',
      productGroup: 'Product Group',
      productName: 'Product Name',
      confirmOperation: 'Please confirm your operation',
      confirmRemoveLabel: 'Confirm to remove product label?'
    }
  },
  zh: {
    productLabelManage: {
      queryCondition: '查询条件',
      selectLabel: '请选择商品标签',
      inputProductName: '请输入商品名称',
      inputProductId: '请输入商品编号',
      labeledProducts: '打标商品',
      labelName: '标签名称',
      productId: '商品ID',
      productImage: '商品图片',
      productGroup: '商品分组',
      productName: '商品名称',
      confirmOperation: '请确认您的操作',
      confirmRemoveLabel: '确定取消商品打标？'
    }
  }
}